import { event } from 'react-ga';

export const gaEventAnalytics = (eventName) => {
  event({
    category: eventName,
    action: eventName,
    label: eventName,
  });
};
